import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "navbar-brand",
  href: "#"
}, "Broadstack Receiver", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#mainNavbarToggle",
  "aria-controls": "mainNavbarToggle",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "collapse navbar-collapse",
  id: "mainNavbarToggle"
}
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_7 = { class: "navbar-text small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("nav", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (this.$store.getters.getUserAuthority.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("ul", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.$router.options.routes, (route, idx) => {
                  return (_openBlock(), _createBlock("li", {
                    class: ['nav-item', route.children ? 'drodown position-relative' : ''],
                    key: idx
                  }, [
                    (route.meta && route.meta.navlabel && (route.meta.anon || this.$store.getters.getUserAuthority.indexOf(route.meta.authority) > -1))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: route.path,
                          class: "nav-link text-nowrap"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(route.meta.navlabel), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (route.children)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "nav-link dropdown-toggle",
                          href: "#",
                          id: route.name + 'Options',
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, _toDisplayString(route.name), 9, ["id"]))
                      : _createCommentVNode("", true),
                    (route.children)
                      ? (_openBlock(), _createBlock("ul", {
                          key: 2,
                          class: "dropdown-menu",
                          "aria-labelledby": route.name + 'Options'
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(route.children, (subroute, subidx) => {
                            return (_openBlock(), _createBlock("li", { key: subidx }, [
                              (subroute.meta && subroute.meta.navlabel && (subroute.meta.anon || this.$store.getters.getUserAuthority.indexOf(subroute.meta.authority) > -1))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: subroute.path,
                                    class: "dropdown-item text-nowrap"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subroute.meta.navlabel), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 8, ["aria-labelledby"]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]),
              _createVNode("span", _hoisted_7, " Logged in as " + _toDisplayString(this.$store.getters.getUserName), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}